import { render, staticRenderFns } from "./attachmentsViewer.vue?vue&type=template&id=45b8a9f4&scoped=true&"
import script from "./attachmentsViewer.vue?vue&type=script&lang=js&"
export * from "./attachmentsViewer.vue?vue&type=script&lang=js&"
import style0 from "./attachmentsViewer.vue?vue&type=style&index=0&id=45b8a9f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b8a9f4",
  null
  
)

export default component.exports